export default {
  namespaced: true,
  state: {
    info: {},
    migrations: null
  },
  getters: {
    getInfo: (state) => state.info,
    getMigration: (state) => state.migrations,
  },
  mutations: {
    UPDATE_INFO (state, status) {
      state.info = status
    },
    UPDATE_MIGRATION (state, status) {
      state.migrations = status
    }
  },
  actions: {
    updateInfo ({ commit }, status) {
      commit('UPDATE_INFO', status)
    },
    updateMigration ({ commit }, status) {
      commit('UPDATE_MIGRATION', status)
    }
  }
}
